import React from 'react'
import { Col, Card, CardHeader, CardBody } from 'reactstrap'
import NodeAdder from './NodeAdder'
import NodeLister from './NodeLister'

export default function NodeTagger (props) {
  return (
    <Col>
      <Card>
        <CardHeader>
          Tag Nodes
        </CardHeader>
        <CardBody>
          <NodeLister nodeTags={props.nodeTags} nodes={props.nodes} deleteNodeTag={props.deleteNodeTag} />
          <NodeAdder nodeTags={props.nodeTags} nodes={props.nodes} addNodeTag={props.addNodeTag} active={props.active}/>
        </CardBody>
      </Card>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/CreateManageContent/NodeTagger.js